import getEnumName from './getEnumName';

export default (code: string): string => {
  return getEnumName('TRAINING_CLASS', code);
};
